import camelCase from "lodash/camelCase";

const activate = (state, resource) => {
  let pluralizedType = resource.type + (resource.type === "history" ? "" : "s");
  var type = camelCase(pluralizedType);
  state[type].activeId = resource.id;
};

const setResources = (state, payload) => {
  let type = camelCase(payload.type);
  state[type].content = payload.resources;
  state[type].resolvedAt = Date.now();
};

const pushResource = (state, resource) => {
  let pluralizedType = resource.type + (resource.type === "history" ? "" : "s");
  var type = camelCase(pluralizedType);

  const content = state[type].content;
  let index = content.findIndex((item) => item.id === resource.id);
  if (index >= 0) {
    content.splice(index, 1, resource);
  } else {
    content.push(resource);
  }
};

const deleteResource = (state, payload) => {
  var type = camelCase(payload.type);
  var key = payload.primaryKey || "id";
  let index = state[type].content.findIndex((item) => item[key] === payload.id);
  if (index >= 0) {
    state[type].content.splice(index, 1);
  }
};

export default {
  activate,
  setResources,
  pushResource,
  deleteResource,
};
